var map = {
	"./en.json": "./ClientApp/locale/igaming-lottery/en.json",
	"./pt.json": "./ClientApp/locale/igaming-lottery/pt.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./ClientApp/locale/igaming-lottery ./ClientApp/locale/igaming-lottery sync recursive ^\\.\\/.*\\.json$";